import { useEffect, useState } from 'react'
import { isCarrierLogin } from 'tools/auth'
import { getConnectedAccounts } from 'api'
import { saveCarrierDataToLocalStorage } from 'tools/carrierStorage'
import { reportException } from 'tools/logs'

export interface CarrierCodeData {
  carrierId: string
  carrierCodeType: string
  carrierCodeValue: string
  carrierPolicyId: string
}

const readFromStorage = (): CarrierCodeData => ({
  carrierId: localStorage.getItem('carrierId') ?? '',
  carrierCodeType: localStorage.getItem('carrierCodeType') ?? '',
  carrierCodeValue: localStorage.getItem('carrierCodeValue') ?? '',
  carrierPolicyId: localStorage.getItem('carrierPolicyId') ?? '',
})

export const useCarrierCodeBootstrap = (): CarrierCodeData => {
  const [data, setData] = useState<CarrierCodeData>(readFromStorage)

  useEffect(() => {
    // Non-carrier logins (insurer, agent) skip this fetch — their carrier context is already
    // in localStorage, populated by the carrier selection flow before any carrier page mounts.
    if (!isCarrierLogin()) return

    const codeType = localStorage.getItem('carrierCodeType')
    const codeValue = localStorage.getItem('carrierCodeValue')
    if (codeType && codeValue) return

    let cancelled = false

    getConnectedAccounts()
      .then((res: any) => {
        if (cancelled) return
        saveCarrierDataToLocalStorage(res)
        setData(readFromStorage())
      })
      .catch((err: any) => {
        if (cancelled) return
        reportException(err)
      })

    return () => {
      cancelled = true
    }
  }, [])

  return data
}
